<template>
	<div class="form-number">
		<!-- Text block w/ label -->
		<label :for="_uid" >{{title}}</label>
		<div :class='{focus: focussed, "input-block": true, disabled }'>
			<div class="prefix" v-if='prefix'>{{prefix}}</div>
			<div class="spacer" v-if='!prefix'>&nbsp;</div>
			<input
				:id="_uid"
				:placeholder='placeholder'
				ref="item"
				:name="name"
				:autocomplete="autocomplete"
				:value="value"
				@blur.lazy="prettify()"
				@focus="onFocus()"
				:disabled="disabled"
				:maxlength="maxlength"
				type="text"
			required>
		</div>
	</div>
</template>

<script>

export default {
	name: "FormInput",
	props: {
		value: {
			default: ""
		},
		required: {
			default: false
		},
		prefix: {
			default: false
		},
		disabled: {
			default: false
		},
		title: {
			default: ""
		},
		maxlength: {
			default: 99
		},
		name: {
			default: "input"
		},
		autocomplete: {
			default: ""
		},
		placeholder: {
			default: ""
		},
		step: {
			default: 0.01
		},
		hint: {
			default: ""
		}
	},
	data(){
		return {
			focussed: false
		};
	},
	methods: {
		onFocus(){
			this.focussed = true;
		},
		offFocus(){
			this.focussed = false;
		},
		update() {
			this.$emit('input', this.$refs.item.value);
		},
		// Convert value to confirm to precision
		prettify(){
			if(this.step <= 0) return;
			let temp_val = 0;
			if(this.$refs.item.value != "") temp_val = this.$refs.item.value.replace(/[^0-9.]/g,'');
			temp_val = (Math.ceil(temp_val/this.step)*this.step);
			this.$refs.item.value = temp_val.toFixed(this.precision(this.step));
			if(this.$refs.item.value === NaN || this.$refs.item.value == "NaN") this.$refs.item.value = this.$refs.item.value.replace(/\D/g,'');
			this.offFocus();
			this.update();
		},
		// Returns the precision of the provided number ex. 1.0001 = 4
		precision(a) {
			for(var i = 0; i < 15; i++){
				if((a * Math.pow(10, i)) % 1 == 0) return i;
			}
			return 15;
		}
	}
};
</script>

<style scoped lang="scss">
	.input-block{
		position: relative;
		display: flex;
		align-items: center;
		color: #919eab;
		cursor: text;
		border: 1px solid #CDCDCD;
		border-radius: 7px;
	}
	label{
		width: 100%;
		margin-bottom: 5px;
		font-family: 'proximanova-bold';
		font-size: 18px;
	}
	input{
		position: relative;
		z-index: 20;
		display: block;
		flex: 1 1 0%;
		width: 100%;
		margin: 0;
		padding: 8px 20px 8px 3px;
		background: none;
		border: 1px solid transparent;
		height: 42px;
	}
	input:focus{
		outline: 0px;
	}
	.prefix{
		position: relative;
		z-index: 20;
		text-align: center;
		width: 20px;
		margin-left: 5px;
	}
	.spacer{
		width: 10px;
	}
	.disabled{
		background-color: #EBEBEB;
	}
</style>
